const ToolboxInfo = {
  maxInstances: {
    program_image_click_event_block: 2,
    image_getter_x_block: 2,
    image_setter_x_block: 2,
    label_text_show_setter_block: 2,
  },
  json: {
    kind: "categoryToolbox",
    contents: [
      {
        kind: "category",
        toolboxitemid: "category",
        contents: [
          {
            kind: "block",
            type: "program_image_click_event_block",
          },
          {
            kind: "block",
            type: "image_getter_x_block",
          },
          {
            kind: "block",
            type: "image_setter_x_block",
            inputs: {
              value: {
                shadow: {
                  type: "math_number",
                  fields: {
                    NUM: 0,
                  },
                },
              },
            },
          },
          {
            kind: "block",
            type: "label_text_show_setter_block",
          },
        ],
      },
    ],
  },
};

export default ToolboxInfo;
